/* ==========================================================================
   RACINESFIX - Le diagnostic (v3 PARTIE 7.1)
   --------------------------------------------------------------------------
   Six questions, une par écran. Un tap fait avancer. Aucune saisie clavier.

   Ce fichier est autonome : aucune dépendance, aucune requête réseau,
   aucun cookie, aucun stockage local. Les réponses voyagent dans l'URL.

   POURQUOI PAS DE STOCKAGE
   Le v3 vise INP sous 200 ms sur un Android milieu de gamme. Tout ce qui
   suit est de la manipulation de classe et d'attribut `hidden` : pas de
   layout recalculé, pas d'animation de hauteur, rien qui bloque le thread
   principal. Et sans cookie ni localStorage, il n'y a rien à consentir.

   DÉGRADATION
   Sans ce fichier, les six <fieldset> s'affichent à la suite et le bouton
   <noscript> soumet le formulaire. Le résultat s'affiche quand même.
   C'est voulu : la page est une cible de publicité payante, et une page
   blanche sur échec de script est le pire scénario possible.
   ========================================================================== */

(function () {
  'use strict';

  var form = document.querySelector('[data-rx-quiz]');
  if (!form) return;

  var screens = Array.prototype.slice.call(
    form.querySelectorAll('[data-rx-screen]')
  );
  if (!screens.length) return;

  var fill = form.querySelector('[data-rx-quiz-fill]');
  var bar = form.querySelector('[data-rx-quiz-bar]');
  var total = screens.length;
  var current = 0;

  /* Avec JavaScript, un seul écran est visible : on cache tout puis on
     montre le premier. Le HTML livre déjà les écrans 2 à 6 en `hidden`,
     donc rien ne clignote au chargement (pas de CLS). */
  /* Le mouvement entre deux questions.

     La question quittée glisse vers la gauche en s'effaçant, la suivante
     arrive depuis la droite. En arrière, le sens s'inverse : c'est ce qui
     fait comprendre qu'on revient, sans rien écrire.

     Le mouvement porte sur `transform` et `opacity` UNIQUEMENT, jamais
     sur une hauteur ou une marge : ce sont les deux seules propriétés que
     le navigateur anime sans recalculer la mise en page, donc sans peser
     sur l'INP (v3 PARTIE 13).

     `prefers-reduced-motion` est respecté dans la feuille de style : la
     classe est posée ici dans tous les cas, et c'est le CSS qui décide
     s'il l'anime. Le JavaScript n'a pas à connaître cette préférence. */
  var DUREE = 220;

  function show(index, sens) {
    if (index < 0 || index >= total) return;

    var sortant = screens[current];
    var entrant = screens[index];
    var arriere = sens === 'arriere';

    if (sortant && sortant !== entrant) {
      sortant.classList.add(arriere ? 'rx-quiz__screen--out-r' : 'rx-quiz__screen--out-l');
      window.setTimeout(function () {
        sortant.setAttribute('hidden', '');
        sortant.classList.remove('rx-quiz__screen--out-l', 'rx-quiz__screen--out-r');
      }, DUREE);
    }

    screens.forEach(function (s, i) {
      if (i !== index && s !== sortant) s.setAttribute('hidden', '');
    });

    entrant.removeAttribute('hidden');
    entrant.classList.add(arriere ? 'rx-quiz__screen--in-l' : 'rx-quiz__screen--in-r');
    /* Forcer un reflow avant de retirer la classe, sinon le navigateur
       regroupe les deux changements et aucune transition ne se joue. */
    void entrant.offsetWidth;
    entrant.classList.remove('rx-quiz__screen--in-l', 'rx-quiz__screen--in-r');

    current = index;
    progress(index + 1);

    /* Le focus part sur la légende de la nouvelle question, sinon un
       utilisateur au clavier reste sur un bouton qui vient de disparaître
       et le lecteur d'écran n'annonce pas le changement d'écran. */
    var legend = screens[index].querySelector('.rx-quiz__legend');
    if (legend) {
      legend.setAttribute('tabindex', '-1');
      try {
        legend.focus({ preventScroll: true });
      } catch (e) {
        legend.focus();
      }
    }
  }

  function progress(step) {
    var pct = Math.round((step / total) * 100);
    if (fill) fill.style.width = pct + '%';
    if (bar) {
      bar.setAttribute('aria-valuenow', String(step));
      bar.setAttribute('aria-valuetext', 'Question ' + step + ' sur ' + total);
    }
  }

  /* Un tap sur une carte sélectionne ET avance. Le v3 : « Grandes cartes
     tactiles de 64 px, un tap fait avancer. »

     Le délai de 180 ms laisse voir l'état sélectionné avant la transition.
     Sans lui, la carte semble ne pas avoir répondu et l'utilisateur tape
     une deuxième fois, ce qui répond à la question suivante par erreur.
     C'est le défaut le plus courant de ce motif d'interface. */
  var ADVANCE_DELAY = 180;
  var locked = false;

  form.addEventListener('change', function (ev) {
    var input = ev.target;
    if (!input || !input.matches('[data-rx-answer]')) return;
    if (locked) return;
    locked = true;

    window.setTimeout(function () {
      locked = false;
      if (current >= total - 1) {
        submit();
      } else {
        show(current + 1);
      }
    }, ADVANCE_DELAY);
  });

  /* « Passer » : on vide la réponse de l'écran courant puis on avance.
     Vider est important : si quelqu'un répond, revient en arrière, puis
     passe, la vieille réponse ne doit pas rester dans l'URL. */
  form.addEventListener('click', function (ev) {
    var skip = ev.target.closest('[data-rx-skip]');
    if (skip) {
      ev.preventDefault();
      var inputs = screens[current].querySelectorAll('[data-rx-answer]');
      Array.prototype.forEach.call(inputs, function (i) {
        i.checked = false;
      });
      if (current >= total - 1) {
        submit();
      } else {
        show(current + 1);
      }
      return;
    }

    var back = ev.target.closest('[data-rx-back]');
    if (back) {
      ev.preventDefault();
      show(current - 1, 'arriere');
    }
  });

  /* Soumission. On construit l'URL à la main plutôt que de laisser le
     navigateur sérialiser le formulaire : les questions passées ne doivent
     pas apparaître comme des paramètres vides, sinon la page de résultat
     ne peut pas distinguer « passé » de « répondu avec une valeur vide ».
     Le v3 est explicite : une question passée fait disparaître le fragment,
     jamais un emplacement vide. */
  function submit() {
    var params = [];
    screens.forEach(function (s) {
      var key = s.getAttribute('data-rx-key');
      var checked = s.querySelector('[data-rx-answer]:checked');
      if (key && checked && checked.value) {
        params.push(
          encodeURIComponent(key) + '=' + encodeURIComponent(checked.value)
        );
      }
    });

    var base = form.getAttribute('action') || window.location.pathname;
    var url = base + (params.length ? '?' + params.join('&') : '');
    window.location.assign(url + '#rx-resultat');
  }

  /* La première question est obligatoire (v3) : tant qu'elle n'a pas de
     réponse, il n'y a ni « Passer » ni retour possible. C'est déjà le cas
     dans le HTML, qui n'y met pas ces boutons. Rien à faire ici. */

  show(0);

  /* ==================================================================
     LA PAGE DE RÉSULTAT

     Tout est composé ici et non en Liquid : `request.url` et
     `request.query_string` sont VIDES dans Liquid sur Shopify. Vérifié
     par une sonde sur le thème de développement, et confirmé par la
     documentation : l'objet `request` n'expose que design_mode, host,
     locale, origin, page_type, path et visual_preview_mode. Les pages
     sont mises en cache sans leurs paramètres d'URL.

     Le texte français reste dans le thème (voir rx-quiz-result.liquid) :
     ce fichier ne fait que choisir et révéler des fragments existants.
     Aucune phrase destinée au visiteur n'est écrite dans ce JavaScript.
     ================================================================== */

  var result = document.querySelector('[data-rx-result]');
  var vide = document.querySelector('[data-rx-result-vide]');
  if (!result) return;

  function param(name) {
    var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
    return m ? decodeURIComponent(m[1]) : '';
  }

  var A = {
    sexe: param('sexe'),
    zone: param('zone'),
    depuis: param('depuis'),
    essaye: param('essaye'),
    cheveux: param('cheveux'),
    objectif: param('objectif')
  };

  /* Une réponse inconnue est traitée comme absente : l'URL est publique
     et modifiable à la main, on ne compose jamais à partir d'une valeur
     qu'on n'a pas écrite soi-même. */
  var VALID = {
    sexe: ['homme', 'femme'],
    zone: ['golfes', 'sommet', 'raie', 'volume'],
    depuis: ['recent', 'moyen', 'long', 'inconnu'],
    essaye: ['rien', 'shampoings', 'complements', 'minoxidil'],
    cheveux: ['lisses', 'boucles', 'crepus'],
    objectif: ['stopper', 'densifier', 'entretenir', 'comprendre']
  };
  Object.keys(A).forEach(function (k) {
    if (VALID[k].indexOf(A[k]) === -1) A[k] = '';
  });

  /* Rien d'exploitable : on laisse l'invitation à répondre. */
  if (!A.zone && !A.depuis && !A.cheveux) return;

  if (vide) vide.setAttribute('hidden', '');

  /* LE QUESTIONNAIRE DISPARAÎT QUAND LE RÉSULTAT ARRIVE.

     Il restait affiché au-dessus du résultat, revenu à la question 1 :
     on lisait donc « Vous êtes ? » juste avant sa propre réponse. Le
     parcours est linéaire, pas cumulatif : une fois répondu, on lit le
     résultat, pas le formulaire qu'on vient de remplir.

     Le chapô part avec lui : « Six questions, moins d'une minute » n'a
     plus de sens une fois les six questions passées. */
  if (form) form.setAttribute('hidden', '');
  var chapo = document.querySelector('.rx-pagehead');
  if (chapo) {
    var intro = chapo.querySelector('p');
    if (intro) intro.setAttribute('hidden', '');
  }

  function frag(key) {
    var el = result.querySelector('[data-rx-frag="' + key + '"]');
    return el ? el.textContent.trim() : '';
  }

  /* ---- 1. Le rappel des réponses, dans leurs mots ----
     Les fragments absents ne laissent pas de trou : la phrase est
     assemblée à partir de ce qui existe, puis ponctuée. */
  var bits = [];
  if (A.zone) bits.push(frag('zone:' + A.zone));
  if (A.depuis && A.depuis !== 'inconnu') bits.push(frag('depuis:' + A.depuis));
  if (A.cheveux) bits.push(frag('cheveux:' + A.cheveux));

  var recap = result.querySelector('[data-rx-recap]');
  if (recap && bits.length) {
    /* Les fragments de zone commencent par une majuscule, ceux
       d'ancienneté et de type de cheveux par une minuscule, parce qu'ils
       sont écrits pour venir en deuxième position. Si la zone a été
       passée, c'est donc « depuis deux ans... » qui ouvre la phrase.
       On remet la majuscule sur le premier fragment retenu, quel qu'il
       soit : une phrase française commence par une capitale. */
    var first = bits[0];
    bits[0] = first.charAt(0).toUpperCase() + first.slice(1);
    recap.textContent = bits.join(', ') + '. ' + frag('suffixe');
  }

  /* ---- L'objectif, sous le mécanisme ---- */
  if (A.objectif) {
    var src = result.querySelector('[data-rx-obj="' + A.objectif + '"]');
    var dst = result.querySelector('[data-rx-objectif]');
    if (src && dst) {
      dst.innerHTML = src.innerHTML;
      dst.removeAttribute('hidden');
    }
  }

  /* ---- 2. PROPOSITION de tableau : la durée conseillée ----
     Tranché par Tal le 18.10.2026 : toujours 4 mois (voir plus bas).

     Facteur dominant : l'ancienneté, parce que c'est elle qui détermine
     combien de cycles il faut pour juger. La zone corrige d'un cran :
     les golfes et le sommet demandent plus de temps qu'une perte de
     volume diffuse. */
  var duree = '';
  if (A.depuis === 'recent') duree = '1';
  else if (A.depuis === 'moyen') duree = '2';
  else if (A.depuis === 'long') duree = '4';

  if (duree && duree !== '4' && (A.zone === 'golfes' || A.zone === 'sommet')) {
    duree = duree === '1' ? '2' : '4';
  }

  /* Ancienneté passée : on se rabat sur la zone seule, et dans le doute
     sur la durée la plus courte. Le v3 et rx-packchooser disent la même
     chose : « Dans le doute, commencez par un mois. » */
  if (!duree && A.zone) {
    duree = (A.zone === 'golfes' || A.zone === 'sommet') ? '2' : '1';
  }
  /* Décision de Tal, 18.10.2026 : le diagnostic conseille et présélectionne toujours 4 mois, comme la fiche produit. */
  duree = '4';

  if (duree) {
    var dsrc = result.querySelector('[data-rx-duree-txt="' + duree + '"]');
    var box = result.querySelector('[data-rx-duree-box]');
    var nom = result.querySelector('[data-rx-duree-nom]');
    var why = result.querySelector('[data-rx-duree-why]');
    if (dsrc && box) {
      if (nom) nom.textContent = dsrc.getAttribute('data-nom') || '';
      if (why) why.textContent = dsrc.textContent.trim() + '.';
      box.removeAttribute('hidden');
      box.setAttribute('data-rx-duree', duree);
    }
  }

  /* ---- 3. PROPOSITION : les trois réponses de FAQ ----
     Q9 (« quand verrai-je un changement ») est toujours présente : c'est
     la question que tout le monde se pose devant un résultat.
     Les deux autres suivent ce que la personne a dit. */
  var codes = ['Q9'];
  codes.push(A.essaye && A.essaye !== 'rien' ? 'Q12' : 'Q4');

  if (A.cheveux === 'crepus' || A.cheveux === 'boucles') codes.push('Q8');
  else if (A.zone === 'golfes' || A.zone === 'sommet') codes.push('Q8');
  else codes.push('Q10');

  var faqBox = result.querySelector('[data-rx-faq-box]');
  var shown = 0;
  codes.forEach(function (c) {
    var item = result.querySelector('[data-rx-faq-item="' + c + '"]');
    if (item) {
      item.removeAttribute('hidden');
      shown++;
    }
  });
  if (faqBox && shown) faqBox.removeAttribute('hidden');

  /* Le résultat est composé : on le montre. `hidden` jusqu'ici évite
     d'afficher une carcasse vide pendant l'exécution du script. */
  result.removeAttribute('hidden');

  /* TOUT CE QUI SUIT LE RÉSULTAT.
     Le bloc d'achat et la garantie restent masqués pendant les six
     questions : montrer un prix avant d'avoir dit ce qu'on recommande
     inverse le parcours. Ils apparaissent ici, une fois le résultat
     composé, dans l'ordre imposé par le v3 PARTIE 7.1. */
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-rx-apres]'),
    function (el) { el.removeAttribute('hidden'); }
  );

  /* ---- Report de la durée vers le bloc d'achat ----
     On coche la carte correspondante, puis racines.js reprend la main.

     `change` est déclenché explicitement : cocher une radio en
     JavaScript n'émet aucun événement, et sans lui le prix affiché
     resterait celui de la première variante. */
  if (!duree) return;

  var cards = document.querySelectorAll('.rx-offers [data-variant]');
  Array.prototype.forEach.call(cards, function (input) {
    var label = input.closest('label');
    if (!label) return;
    var text = (label.textContent || '').toLowerCase();
    /* « 1 mois », pas « 1 » seul : sinon « 4 ampoules » ferait mouche. */
    if (text.indexOf(duree + ' mois') !== -1) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
